export default __webpack_public_path__ + "static/B0100-69f7a065554aade0381b29b2db0d2478.png";